import { ResumeData, ResumeTemplate } from '../types';
import { ATSTemplate } from './templates/ATSTemplate';
import { ModernTemplate } from './templates/ModernTemplate';

interface ResumePreviewProps {
    data: ResumeData;
    template: ResumeTemplate;
}

export function ResumePreview({ data, template }: ResumePreviewProps) {
    const safeData: ResumeData = {
        ...data,
        settings: data.settings || {
            compactSpacing: false,
            maxBulletLength: 150,
        },
    };

    return (
        <div className="resume-preview bg-white shadow-lg" style={{ minHeight: '11in' }}>
            {template === 'ats' ? (
                <ATSTemplate data={safeData} />
            ) : (
                <ModernTemplate data={safeData} />
            )}
        </div>
    );
}
